import React from "react";

import { Typography, Grid, Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { InfoCard } from "components/admin/InfoCard";
import { BlockStandard } from "components/admin/BlockStandard";

const useStyles = makeStyles()((theme) => ({
  gridItem: {
    backgroundColor: theme.palette.backgrounds.secondary,
    flexGrow: 1,
    padding: theme.spacing(3, 2),
  },
  treeContainer: {
    background: `no-repeat center border-box url("/static/img/descarb.png")`,
    backgroundSize: "contain",
  },
}));

const USER_LOCALE = "pt-BR";

export const CarbonFootprint = ({ info }) => {
  const { classes } = useStyles();

  const co2AvoidedFormatted = info?.co2Avoided.toLocaleString(USER_LOCALE, {
    maximumFractionDigits: 2,
  });

  const kilometersNotDriven = info?.kilometersNotDriven.toLocaleString(
    USER_LOCALE,
    {
      maximumFractionDigits: 0,
      useGrouping: false,
    }
  );

  return (
    <>
      <BlockStandard>
        <Box className={classes.treeContainer} py={4}>
          <Grid item container xs={6} direction="column" gap={2}>
            <InfoCard
              loading={!info?.treesPlanted}
              title="Árvores plantadas"
              value={`${info?.treesPlanted.toLocaleString(USER_LOCALE, {
                maximumFractionDigits: 0,
              })}`}
            />
            <InfoCard
              loading={!info?.co2Avoided}
              title="Emissões de CO2 evitadas"
              value={`${co2AvoidedFormatted} ton`}
            />
            <InfoCard
              loading={!info?.kilometersNotDriven}
              title="Km não rodados"
              value={`${kilometersNotDriven} km`}
            />
          </Grid>
        </Box>
      </BlockStandard>

      <BlockStandard>
        <Grid item>
          <Typography variant="h2">Seja CO2e Net Zero!</Typography>
          <Typography variant="body1">
            Objetivos de desenvolvimento sustentável para os quais você
            contribui:
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between">
          <img
            src="/static/libAssets/sdg7_badge.png"
            alt="energia limpa e acessível"
          />
          <img
            src="/static/libAssets/sdg11_badge.png"
            alt="cidades e comunidades sustentáveis"
          />
          <img
            src="/static/libAssets/sdg13_badge.png"
            alt="ação contra a mudança global do clima"
          />
        </Grid>
      </BlockStandard>
    </>
  );
};
